module.exports = __webpack_public_path__ + "assets/img/type1.1b11979c.png";